import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody, MDBCardHeader,
    MDBCol,
    MDBContainer,
    MDBFile,
    MDBIcon,
    MDBInput,
    MDBRow,
    MDBTypography
} from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import './../../App.css';

export default function IdCards() {
  const [backgroundImage, setBackgroundImage] = useState('https://opengrit.com/images/background2');
  const [logoImage, setLogoImage] = useState('https://opengrit.com/images/logoCircle');
  const [firstName, setFirstName] = useState('Ram');
  const [middleName, setMiddleName] = useState(' ');
  const [lastName, setLastName] = useState('Chalicham');
  const [companyName, setCompanyName] = useState('OpenGrit');
  const [phoneNumber, setPhoneNumber] = useState('612 865 8133');
  const [websiteURL, setWebsiteURL] = useState('https://opengrit.com');
  const [role, setRole] = useState('CEO');
  const [email, setEmail] = useState('ram@opengrit.com');
  const handleBackgroundImageChange = (event) => {
    const value = event.target.type === 'file' ? URL.createObjectURL(event.target.files[0]) : event.target.value;
    setBackgroundImage(value);
  };

  const handleLogoImageChange = (event) => {
    const value = event.target.type === 'file' ? URL.createObjectURL(event.target.files[0]) : event.target.value;
    setLogoImage(value);
  };

  // const handleBackgroundImageChange = (event) => {
  //   setBackgroundImage(event.target.value);
  // };

  // const handleLogoImageChange = (event) => {
  //   setLogoImage(event.target.value);
  // };

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleMiddleNameChange = (event) => {
    setMiddleName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleCompanyNameChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleWebsiteURLChange = (event) => {
    setWebsiteURL(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleEmailChange = (event) => {
    setRole(event.target.value);
  };

  const captureIDCardAsImage = () => {
    const cardContainer = document.getElementById('IdCards');
    html2canvas(cardContainer).then(function (canvas) {
      const image = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = image;
      a.download = 'IDCard.png';
      a.click();
    });
  };

  const generateIDCardPDF = () => {
    const cardContainer = document.getElementById('IdCards');
    const pdf = new jsPDF();

    html2canvas(cardContainer).then(function (canvas) {
      const image = canvas.toDataURL('image/png');

      pdf.addImage(image, 'PNG', 0, 0, 210, 297);

      pdf.html(cardContainer, {
        callback: function () {
          pdf.save('IDCard.pdf');
        },
      });
    });
  };

  return (
    <>
      <MDBContainer className='d-flex align-items-center justify-content-center'>
        <header id='IdCards' className='text-center img-fluid mt-2'>
          <div
            className='text-center bg-image rounded light mb-1'
            style={{
              backgroundImage: `url('${backgroundImage}')`,
              padding: '8rem 10rem',
              maxWidth: '100%',
            }}
          >
            <div
              className='mask d-flex align-items-center justify-content-center bg-image hover-overlay shadow-2-strong rounded'
              style={{ backgroundColor: 'rgba(1, 1, 1, 1)' }}
            >
              <MDBContainer className='d-flex align-items-center justify-content-center'>
                <MDBRow className='align-items-center justify-content-center'>
                  <MDBCol className='d-flex align-items-center justify-content-center'>
                    <div className='d-flex align-items-center justify-content-center'>
                      <img
                        src={logoImage}
                        className='rounded'
                        style={{ height: '50.5px' }}
                        alt='Logo'
                      />
                     
                      <p className='mb-0 text-light'>
                        <h3>
                          <strong className='text-white'>{companyName}</strong>
                        </h3>
                      </p>
                      <figure className='mb-0'>
                        <figcaption className='blockquote-footer mb-0 text-light'>
                          <cite title='Source Title'>
                            <strong className='text-white'>{role}</strong>
                          </cite>
                        </figcaption>
                      </figure>
                    </div>
                  </MDBCol>
                  <MDBCol md='8' className='d-flex justify-content-end align-items-center'>
                    <MDBTypography className='mb-0 text-light text-end'>
                      <MDBTypography listUnStyled className='mb-0 text-end'>
                      <li className="d-flex align-items-center">
  <MDBIcon fas icon="check" className='text-warning me-2' />
  <strong>{firstName}</strong>  
  {middleName && <span className='mx-1'>{middleName}</span>}
 
  <strong>{lastName}</strong>
</li>

                        <li className='d-flex align-items-center'>
                        <MDBIcon fas icon="phone" className='text-warning me-2' />
                          <strong>{phoneNumber}</strong>
                        </li>
                        <li className="d-flex align-items-center">
                          <MDBIcon far icon="envelope" className='text-warning me-2' /><strong >{email}</strong>
                        </li>
                        <li className='d-flex align-items-center'>
                        <MDBIcon fas icon="globe" className='text-warning me-2' />
                          <strong>{websiteURL}</strong>
                        </li>
                      </MDBTypography>
                    </MDBTypography>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </div>
          </div>
        </header>
      </MDBContainer>
     
    <MDBCol  className='d-flex justify-content-center'>
        <MDBCard  className="text-black d-flex   justify-content-between" >
        <MDBCardHeader className='d-flex justify-content-center'>Key in Card Contents</MDBCardHeader>
        <MDBCardBody className="d-grid gap-3 ms-2 me-2">       
            {/* <MDBInput label='Background Image URL' type='url' onChange={handleBackgroundImageChange} />
            <MDBFile name='Background Image URL' id='Background Image' onChange={handleBackgroundImageChange}/>
            <MDBInput label='Logo Image URL' type='url' onChange={handleLogoImageChange} />
            <MDBFile name='Logo Image' id='Logo Image' onChange={handleLogoImageChange}/> */}
<div >
          <MDBInput className="mb-3" label='Background Image URL' type='url' onChange={handleBackgroundImageChange} />         
         <div style={{ position: 'relative' }} className='mt-2'>
         <MDBFile 
           
           name='BackgroundImage'
           id='BackgroundImage'
           onChange={handleBackgroundImageChange}
         />
  <span style={{ position: 'absolute', top: 0, left:70 }}>
    <p className='position-absolute translate-middle text-primary'>
      <span className='small d-inline'>BackgroundImage</span>
    </p>
  </span>
</div>
        </div>
        <div >
          <MDBInput className="mb-3" label='Logo Image URL' type='url' onChange={handleLogoImageChange} />
        
          <div style={{ position: 'relative' }} className='mt-2'>
  <MDBFile name='LogoImage' id='LogoImage' onChange={handleLogoImageChange} />
  <span style={{ position: 'absolute', top: 0, left:45 }}>
    <p className='position-absolute translate-middle text-primary'>
      <span className='small d-inline'>LogoImage</span>
    </p>
  </span>
</div>

        </div>
            <MDBInput label='First Name' id='idcardsFirstName' type='text' onChange={handleFirstNameChange} />
            <MDBInput label='Middle Name' type='text' onChange={handleMiddleNameChange} />
            <MDBInput label='Last Name' type='text' onChange={handleLastNameChange} />
            <MDBInput label='Company Name' type='text' onChange={handleCompanyNameChange} />
            <MDBInput label='Phone Number' type='tel' onChange={handlePhoneNumberChange} />
            <MDBInput label='Website URL' type='url' onChange={handleWebsiteURLChange} />
            <MDBInput label='Email' type='email' onChange={handleEmailChange} />
            <MDBInput label='Role' type='text' onChange={handleRoleChange} />
         
          </MDBCardBody>
          <MDBCol className='gap-2 d-flex justify-content-center align-items-center mb-4'>
          <MDBBtn
            size='lg'
            className='mx-2 bg-warning text-dark bg-opacity-75'
            onClick={() => captureIDCardAsImage()}
          >
            ID as image
          </MDBBtn>
          <MDBBtn
            size='lg'
            className='mx-2 bg-primary text-black bg-opacity-75'
            onClick={() => generateIDCardPDF()}
          >
            ID as PDF
          </MDBBtn>
          </MDBCol>
        </MDBCard>
        </MDBCol>
    </>
  );
}
